import { render } from "./MainSanPhamThueHuongDan.vue?vue&type=template&id=04c6640a&scoped=true"
import script from "./MainSanPhamThueHuongDan.vue?vue&type=script&lang=js"
export * from "./MainSanPhamThueHuongDan.vue?vue&type=script&lang=js"

import "./MainSanPhamThueHuongDan.vue?vue&type=style&index=0&id=04c6640a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c6640a"]])

export default __exports__